import React from 'react'

import { ASSIGN_LABELS } from '../_constants/assignConstants'
import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import GroupSelect from './GroupSelect'
import UserSelect from './UserSelect'

const AssignContent = () => {
  const form = useForm()

  const label = ASSIGN_LABELS[form.assign]

  return (
    <FormItem label={label} field="userOrGroup">
      <UserSelect />
      <GroupSelect />
    </FormItem>
  )
}

export default AssignContent
